module.exports = __webpack_public_path__ + "img/sites.7fbe56ba.png";